import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FSideBarComponent} from './fsidebar.component';
//import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {MaterialModule} from 'shared/material.module';

@NgModule({
  imports: [
    CommonModule
    ,MaterialModule
  ],
  declarations: [
    FSideBarComponent
  ],  
  entryComponents: []
  ,
  exports: [
    FSideBarComponent
  ]
  ,providers:[
/*     { provide: 'AuthenticationProvider', useClass: AuthenticationService} 
    ,{provide: UPLOAD_SERVICE_CONFIG_TOKEN, useValue: environment.API_UPLOAD_ENDPOINT}  */
  ]
})
export class FSideBarModule {

}
